import { Button } from "../../Atoms/Button";
import { Eye } from "../../Atoms/Eye";
import { Input } from "../../Atoms/Inputs/Input";
import { Pagination } from "../../Atoms/Pagination";
import { Title } from "../../Atoms/Title";
import * as S from "./styles";
import { useClients } from "./useClients";

export const ClientsTemplate = () => {
  const {
    isOpen,
    setIsOpen,
    navigate,
    clientes,
    isMobile,
    pagination,
    setNumberPage,
    handleSubmit,
    register,
    handleReset,
    submitFilter,
    canAccessClients,
    canEditClients,
  } = useClients();
  return (
    <S.Container>
      <S.Wrapper>
        <Title>Clientes Cadastradas</Title>

        <S.WrapperButtons>
          <Button
            data-variant-outline
            onClick={() => setIsOpen((prev) => !prev)}
          >
            <img src="/assets/svgs/icon-filter-dark.svg" alt="Icone filter" />{" "}
            Filtrar
          </Button>
          {canEditClients ? (
            <Button
              data-variant-outline
              onClick={() => {
                navigate("/configuracoes/clientes/cadastro");
              }}
            >
              <img src="/assets/svgs/icon-plus.svg" alt="Icone filter" />{" "}
              Cadastrar
            </Button>
          ) : (
            <></>
          )}
        </S.WrapperButtons>

        {isOpen && (
          <S.FormFilter onSubmit={handleSubmit(submitFilter)}>
            <div>
              <Input id="name" {...register("nome")} label="Nome" />
            </div>

            <div>
              <Input
                id="cpf"
                {...register("cpfCnpj")}
                label="CPF/ CPNPJ"
                maxLength={18}
              />
            </div>
            <div>
              <Input
                id="telefone"
                maxLength={15}
                {...register("telefone")}
                label="Telefone"
              />
            </div>
            <div>
              <Input id="email" {...register("email")} label="E-mail" />
            </div>
            <div>
              <Button type="button" data-variant-text onClick={handleReset}>
                Limpar tudo
              </Button>
              <Button>Buscar</Button>
            </div>
          </S.FormFilter>
        )}

        {canAccessClients && clientes?.length > 0 && (
          <S.Table>
            {clientes.map((i) => (
              <S.TableItem key={Math.random()}>
                <p>
                  NOME: <span>{i.nome}</span>
                </p>

                <div>
                  {canEditClients ? (
                    <Eye
                      onClick={() =>
                        navigate(`/configuracoes/clientes/detalhe?id=${i.uuid}`)
                      }
                    />
                  ) : (
                    <></>
                  )}
                </div>
              </S.TableItem>
            ))}
          </S.Table>
        )}

        {canAccessClients && clientes.length > 0 && (
          <Pagination
            maxPageNumbersDisplayed={isMobile ? 3 : 10}
            key={`${Math.random()} - ${pagination}`}
            totalPage={pagination.totalPage}
            totalRegister={pagination.totalPage}
            actualPage={pagination.actualPage}
            setNumberPage={setNumberPage}
          />
        )}
      </S.Wrapper>
    </S.Container>
  );
};
